import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import deviceAxios from '../../../../utils/axios/device.axios';
import { PaginatedDocuments } from '../../../../interfaces/documents/paginatedStore.type';


const tryToFetchQuestionsDocuments = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedDocuments>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/chatbox/sources?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/sources?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<PaginatedDocuments>(url, data || {});
};

const tryToFetchAllQuestionsDocuments = (data: any): Promise<AxiosResponse<any>> => {
    const url = data?.filters ?
        `${DEVICE_INFO_API_URL}/chatbox/sources/download?search=${data?.filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/sources/download`
    return deviceAxios.put(url, data?.data);
};

const tryToFetchQuestionsDocumentsStats = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/chatbox/sources/monthly-stats`);
};

const tryToCreateReportIssue = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/chatbox/chats/issues/report`, data);
};

const tryToFetchSourceConfusions = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedDocuments>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/chatbox/sources/confusion?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/sources/confusion?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<PaginatedDocuments>(url, data || {});
};

const tryToFetchAllSourceConfusions = (data: any): Promise<AxiosResponse<any>> => {
    const url = data?.filters ?
        `${DEVICE_INFO_API_URL}/chatbox/sources/confusion/download?search=${data?.filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/sources/confusion/download`
    return deviceAxios.put(url, data?.data);
};

const tryToFetchSourceConfusionsStats = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/chatbox/sources/confusion-monthly-stats`);
};

const tryToFetchSentimentQuestions = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedDocuments>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/chatbox/sources/sentiment-stats?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/sources/sentiment-stats?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<PaginatedDocuments>(url, data || {});
};

const tryToFetchAllSentimentQuestions = (data: any): Promise<AxiosResponse<any>> => {
    const url = data?.filters ?
        `${DEVICE_INFO_API_URL}/chatbox/sources/sentiment-stats/download?search=${data?.filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/sources/sentiment-stats/download`
    return deviceAxios.put(url, data?.data);
};

const tryToFetchSentimentQuestionsStats = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/chatbox/sources/sentiment-monthly-stats`);
};

const tryToFetchAllStaffUsageData = (): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/chatbox/topics/user-count/download`
    return deviceAxios.get(url);
};

const tryToFetchStaffUsageStats = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/chatbox/topics/user-count`);
};

export const DocumentsService = {
    tryToFetchQuestionsDocuments,
    tryToFetchAllQuestionsDocuments,
    tryToFetchQuestionsDocumentsStats,
    tryToFetchSourceConfusions,
    tryToFetchAllSourceConfusions,
    tryToFetchSourceConfusionsStats,
    tryToFetchSentimentQuestions,
    tryToFetchAllSentimentQuestions,
    tryToFetchSentimentQuestionsStats,
    tryToFetchAllStaffUsageData,
    tryToFetchStaffUsageStats,
    tryToCreateReportIssue
};